module.exports = __webpack_public_path__ + "static/img/1d0680ab82d2f66108ab06d9311ad340.fe71368.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1d0680ab82d2f66108ab06d9311ad340.png
// module id = 8jXL
// module chunks = 3